module.exports = __webpack_public_path__ + "static/media/poko.15c831e8.jpg";